import {FormControl} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useFieldArray, UseFormReturn} from 'react-hook-form';

import {MultipleLocationsFormType} from '../types/MultipleLocationsFormSchema';
import {VectorRow} from './VectorRow';

export interface VectorsArrayProps {
  control: FormControl<MultipleLocationsFormType>;
  formApi: UseFormReturn<MultipleLocationsFormType>;
}

export function VectorsArray(props: VectorsArrayProps) {
  const {fields} = useFieldArray<MultipleLocationsFormType>({
    name: 'definition',
  });

  return (
    <VStack spacing={4}>
      {fields.map((item, index) => (
        <VectorRow key={item.id} index={index} control={props.control} formApi={props.formApi} />
      ))}
    </VStack>
  );
}
